import {DeathServices} from './DeathServices';
import {ServicesHelper} from '../../services/ServicesHelper';

const PARAMS = {
  environment: 'DAIRY_CATTLE',
};

export const PurchaseServices = {
  endpoint: '/herd_entry',

  list: async (params = {}) => ServicesHelper.list(PurchaseServices.endpoint, {...params, ...PARAMS}),

  post: async (body = {}) => ServicesHelper.post(PurchaseServices.endpoint, {...body, ...PARAMS}),

  put: async (id, body = {}) => ServicesHelper.put(PurchaseServices.endpoint.concat('/', id), {...body, ...PARAMS}),

  delete: async (id) => ServicesHelper.delete(PurchaseServices.endpoint.concat('/', id)),

  categoryAnimal: async (params = {}) => DeathServices.categoryAnimal(params),
};
